import type { FlowNodeResultADT, HandleSubProcessActionConfigure } from '@lighthouse/shared'
import { type ActionFlowNode, getHandleSubProcessVariableValue } from '@lighthouse/shared'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleSubProcess = async (
    node: ActionFlowNode<HandleSubProcessActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    // 查询单条记录暂时只能使用给定的数据源
    const { subProcessId } = config

    if (!subProcessId) {
        throw new Error(t('subProcessNotFound'))
    }

    const args = getHandleSubProcessVariableValue(config, params)

    const { outputArgs, success } = await srv.activeSubProcess({
        workflowId: subProcessId,
        args
    })

    if (!success) {
        throw new Error(t('handleSubProcessError'))
    }

    return {
        type: 'args',
        data: outputArgs,
        success
    }
}
